import { Stethoscope, Building2, Users, Shield } from "lucide-react";

const industries = [
  {
    icon: Stethoscope,
    title: "Dental & Healthcare",
    body: "30+ years partnering with AAO, AACD, Hinman, CDA, Seattle Study Club, Patterson Dental, Nobel Biocare, Straumann, CareCredit, Carestream, RDH, Yankee Dental, Chicago Midwinter, Star of the North, UOP Dugoni, UCLA, Univ. of Michigan, Marquette, and dental schools worldwide.",
    examples: ["Hinman", "AAO", "AACD", "Seattle Study Club", "CareCredit", "CDA", "Yankee Dental", "Chicago Midwinter", "Nobel Biocare", "Straumann", "Patterson", "Carestream"],
  },
  {
    icon: Building2,
    title: "Corporate Leadership",
    body: "Fortune-class brands trust Gary to re-energize teams, sales orgs and leadership offsites — from boardrooms to ballrooms.",
    examples: ["MasterCard", "Boeing", "Hilton", "Hallmark", "Gulfstream", "Hyatt"],
  },
  {
    icon: Users,
    title: "Associations & Conferences",
    body: "Keynote favorite at national gatherings, member associations, and education summits across the United States and abroad.",
    examples: ["NECA", "AMFA", "EERA", "AADOM", "AADGP"],
  },
  {
    icon: Shield,
    title: "Law Enforcement & Service",
    body: "Trusted voice for first responders, correctional leadership, highway patrol, and frontline service teams under pressure.",
    examples: ["CDCR", "Pelican Bay", "National Jail Assoc.", "VI Hwy Patrol"],
  },
];

export default function Industries() {
  return (
    <section id="industries" data-testid="industries-section" className="bg-[#050505] py-24 md:py-32 border-t border-[#262626]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-6">
          <span className="section-num">03 / WHO GARY SERVES</span>
          <div className="divider-red" />
        </div>
        <h2 className="h-display text-5xl md:text-6xl lg:text-7xl max-w-4xl">
          Industries built by <span className="text-[#EC1985]">people</span> — re-energized by Gary.
        </h2>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-5">
          {industries.map((i, idx) => {
            const Icon = i.icon;
            return (
              <div
                key={i.title}
                data-testid={`industry-${idx}`}
                className="surface p-8 md:p-10 hover:border-[#EC1985] transition-colors"
              >
                <div className="flex items-center gap-4 mb-5">
                  <div className="bg-[#EC1985] p-3 text-white">
                    <Icon size={22} />
                  </div>
                  <h3 className="font-display text-2xl md:text-3xl text-white">{i.title}</h3>
                </div>
                <p className="text-white/70 leading-relaxed">{i.body}</p>
                <div className="mt-6 flex flex-wrap gap-2">
                  {i.examples.map((e) => (
                    <span
                      key={e}
                      className="text-xs uppercase tracking-[0.15em] font-bold border border-[#262626] px-3 py-2 text-white/85"
                    >
                      {e}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
